module.exports = __webpack_public_path__ + "static/media/293813.7e3229a3.png";